import { render } from "./AreaDetails.vue?vue&type=template&id=4fb07374&scoped=true&ts=true"
import script from "./AreaDetails.vue?vue&type=script&lang=ts"
export * from "./AreaDetails.vue?vue&type=script&lang=ts"

import "./AreaDetails.vue?vue&type=style&index=0&id=4fb07374&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb07374"]])

export default __exports__